export default __webpack_public_path__ + "static/media/harcen.ae4b7a22.JPG";